import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'

export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video={videos.yes_network.videoUrl}
    title="Watch YES Network with Fubo"
    subtitle="Stream live games and local team coverage. Regional restrictions apply."
    networkSet="sports"
    customNetworks={['yesnetwork', 'msg', 'mlbnetwork']}
    league="MLB"
    logo="https://assets-imgx.fubo.tv/marketing/lp/images/logos/logo-fubo-yes.png?w=451&ch=width&auto=format,compress"
    logoHeight="56px"
    offerBanner={{
      title: ['Special offer applied!', 'Save $30 on your first month of Fubo'],
    }}
  />
)
